import { GooglePayButtonConfig } from '../types';

/**
  This Method is mock and will be implemented in future task
  TODO: NEED MAP ERRORS WITH Backend
  TOKEN - // data.paymentMethodData.tokenizationData.token
  Call our back - createOrder(TOKEN) to create orderId ->
  Call Stores onPaymentAuthorized(orderId, + data from google) ->
  They return to use 'IN_PROGRESS' + 3DS or 'DONE' or 'Error'
 */
export const createOnPaymentAuthorized = (): GooglePayButtonConfig['onPaymentAuthorized'] => async (data) => {
  console.log('onPaymentAuthorized', data);
  return {
    transactionState: 'SUCCESS' as const, // SUCCESS | ERROR
    //   error: {
    //     reason: 'OFFER_INVALID', //
    //     intent: 'SHIPPING_OPTION', //
    //     message: 'asdasdsa'
    //   }
  };
};
